import { Injectable } from '@angular/core'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { CodeService } from '@core/code.service'
import { SpinnerComponent } from '@core/spinner.component'

@Injectable()
export class StageService {
   console: boolean = false
   logPrefix: string = '@core - ' + this.constructor.name

   public spinner: MatDialogRef<SpinnerComponent>

   private isShown?: boolean

   constructor(
      public code: CodeService,
      public dialog: MatDialog
   ) {}

   spinnerShow() {
      this.isShown = this.dialog.getDialogById('spinner-dialog') ? true : false

      if (!this.isShown) {
         this.spinner = this.dialog.open(SpinnerComponent, {
            panelClass: 'app-spinner',
            disableClose: true,
            backdropClass: 'app-spinner-overlay',
            id: 'spinner-dialog',
         })
         this.isShown = true
      }
   }

   spinnerHide() {
      if (this.isShown) this.dialog.getDialogById('spinner-dialog')?.close()
   }
}

